import { handleRequest } from "../utilities/requestHandler";
import customHttp from "./customHTTP";

export const getOptions = () => 
    handleRequest("get", "/options");

export const insertOptions = (req_body) => 
    handleRequest("post", "/options/insert", req_body);

export const getOptionsByKey = (optionKey) =>
    handleRequest("post", "/options/get-by-key", { option_key: optionKey });

export const getReach360SamlKeyStatus = () =>
    customHttp.get("/options/reach360-saml-key/status")
        .then((response) => response.data)
        .catch((error) => error.response?.data || { status: false, message: "Unable to read Reach 360 key status" });

export const saveReach360SamlConfiguration = (payload) =>
    customHttp.post("/options/reach360-saml-configuration", payload)
        .then((response) => response.data)
        .catch((error) => error.response?.data || { status: false, message: "Unable to save Reach 360 SAML settings" });

export const uploadCompanyLogo = (formData) =>
    handleRequest("post", "/options/upload-logo", formData, { headers: { "Content-Type": "multipart/form-data" } });

export const getBrandingLogos = () =>
    handleRequest("get", "/options/branding/logos");

export const uploadCompanyBackdrop = (formData) =>
    handleRequest("post", "/options/upload-backdrop", formData, { headers: { "Content-Type": "multipart/form-data" } });

export const getBrandingBackdrops = () =>
    handleRequest("get", "/options/branding/backdrops");

export const getBrandingStockImages = () =>
    handleRequest("get", "/options/branding/stock-images");

export const deleteBrandingAsset = (assetPath) =>
    handleRequest("post", "/options/branding/delete", { path: assetPath });

export const uploadCompanyStockImage = (formData) =>
    handleRequest("post", "/options/upload-stock-image", formData, { headers: { "Content-Type": "multipart/form-data" } });
